import { render } from "./MobileFooter.vue?vue&type=template&id=0178595e&scoped=true&ts=true"
import script from "./MobileFooter.vue?vue&type=script&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&lang=ts"

import "./MobileFooter.vue?vue&type=style&index=0&id=0178595e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0178595e"]])

export default __exports__